import { Icon, IconProps } from '@chakra-ui/react';
import colors from 'src/theme/colors';

interface SimpleArrowUpProps extends Omit<IconProps, 'css'> {
  color?: string;
}
export default function SimpleArrowUp({ color, ...props }: SimpleArrowUpProps) {
  return (
    <Icon
      width="14px"
      height="14px"
      transform="rotate(180deg)" // Simplest and quickest way to achieve opposite of ArrowDown
      {...props}
    >
      <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          opacity="0.8"
          d="M1 4L7 10L13 4"
          stroke={color || colors.white}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Icon>
  );
}
